import { create } from "zustand";
import { devtools } from "zustand/middleware";

export interface IQRStoreState {
  QRPayload: string | null;
  setQRPayload: (payload: string | null) => void;
}

export const useQRStore = create<IQRStoreState>()(
  devtools(set => ({
    QRPayload: null,
    setQRPayload: (payload: string | null) => { set({ QRPayload: payload }); },
  })),
);
